import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { pBugURLs } from "../../utils/parameters";
import { BugReport, Check } from "@material-ui/icons/";
import Link from "@mui/material/Link";
import { Box } from "@mui/material";
import Select from "@mui/material/Select";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import device from "current-device";
import { useTranslation } from "react-i18next";

const label_list = ["lse", "web", "predicción", "bug", "mejora", "pregunta", "documentación"];
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export function BugReportDialog(props) {
  const { openDialog, setOpenDialog, sendReportBug, closeDialog } = props;
  const { t } = useTranslation("global")

  const input_Title_ref = useRef("");
  const input_Body_ref = useRef("");
  const theme = useTheme();

  const [labels, setLabels] = useState([]);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");

  const handleClickOpenURL = (url) => () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setTitle(input_Title_ref.current.value);
    setBody(input_Body_ref.current.value);
    setLabels(typeof value === "string" ? value.split(",") : value);
  };

  useEffect(() => {
    handleClose();
  }, [closeDialog]);

  useEffect(() => {
  }, [labels]);

  const handleClose = () => {
    setOpenDialog(false);
    setLabels([]);
    setTitle("");
    setBody("");
  };

  const sendForm = () => {
    let labels_data = labels.slice();
    const report_data = {
      title: title,
      body: body,
      labels: labels_data,
    };
    sendReportBug(report_data);
    handleClose();
  };

  function getStyles(name, environments, theme) {
    return {
      fontWeight: environments.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
    };
  }

  // Function true if all fields has data not empty
  const report_completed = () => {
    if (title !== "" && body !== "" && labels.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleFocus = (event) => {
    if (device.type !== 'desktop') {
        const el = event.target.closest('.sig_BugReport_New_InputContainer');
        //el.classList.add('sig_FocusedInputField');
        el.scrollIntoView({behavior: "smooth"});
    }
  }

  return (
    <Dialog className="sig_Drawer_SettingsModal_Root sig_BugReport_New_Root" open={openDialog} onClose={handleClose}>
      <DialogTitle className="sig_Drawer_SettingsModal_Title sig_Main_TitleWithIcon">
        {t("sBugReport.new_report_title")} <BugReport />
      </DialogTitle>
      <DialogContent className="sig_Drawer_SettingsModal_Content sig_BugReport_New_Content">
        <p> {t("sBugReport.new_report_body")} </p>
        <p>
          {t("sBugReport.new_report_body2")} &nbsp;&nbsp;
          <Link component="button" variant="body2" onClick={handleClickOpenURL(pBugURLs.github_issues)}>
            Link
          </Link>
        </p>
        <p> {t("sBugReport.new_report_body3")} </p>

        <hr />
        <br />
        <div data-tour="tourBug_3" className="sig_BugReport_New_Info">
          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title"> {t("sBugReport.form_report_title")} </p>
            <TextField 
              className='sig_BugReport_New_TextField'               
              onFocus={(e) => handleFocus(e)}
              margin="dense" 
              id="bugTitle" 
              fullWidth 
              inputRef={input_Title_ref} 
              defaultValue={title} />
          </div>

          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title"> {t("sBugReport.form_report_body")} </p>
            <TextField 
              className='sig_BugReport_New_TextField' 
              margin="dense" id="bugBody" 
              onFocus={(e) => handleFocus(e)}
              fullWidth 
              inputRef={input_Body_ref} 
              defaultValue={body} 
              multiline rows={4} />
          </div>
          <div>
            <p className="sig_BugReport_New_Title sig_BugReport_New_TitleTags"> {t("sBugReport.form_report_labels")} </p>
            <FormControl className="sig_BugReport_New_TagForm">
              <Select
                id="demo-multiple-chip"
                className="sig_BugReport_New_TagsContainer"
                multiple
                value={labels}
                onChange={handleChange}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.4 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {label_list.map((name) => (
                  <MenuItem key={name} value={name} style={getStyles(name, labels, theme)}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className='sig_BugReport_CheckboxContainer'>
            <FormGroup>
              <FormControlLabel control={<Checkbox size="small" />} label={t("sBugReport.sendDeviceInfo")} />
            </FormGroup>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div>
          {report_completed() ? (
            <Button className="sig_FormDialog_Button" onClick={sendForm}>
              {t("sBugReport.form_report_send")}
            </Button>
          ) : (
            <></>
          )}

          <Button className="sig_FormDialog_Button" onClick={handleClose}>
            {t("sBugReport.form_report_exit")}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}
